import { DomainError, ErrorGroup, pleaseUpdate } from 'domain-errors';

export enum BackendClientErrorCode {
  NoResponse = ErrorGroup.BackendClient + 400,
  InvalidChannelMessage = ErrorGroup.BackendClient + 410,
  InvalidGrpcResponse = ErrorGroup.BackendClient + 420,
  RequiredFieldMissing = ErrorGroup.BackendClient + 430,
}

export class BackendClientDomainError extends DomainError {
  constructor(
    code: BackendClientErrorCode,
    short: string,
    userTitle?: string,
    userDetail?: string,
  ) {
    super(code, short, userTitle ?? short, userDetail ?? pleaseUpdate);
  }
}

export class NoResponseError extends BackendClientDomainError {
  constructor() {
    super(
      BackendClientErrorCode.NoResponse,
      'no response',
      'No response',
      `Our server did not respond to the client's request. ${pleaseUpdate}`,
    );
  }
}

export class InvalidGrpcResponseError extends BackendClientDomainError {
  constructor(public readonly grpcStatusCode: number) {
    super(
      BackendClientErrorCode.InvalidGrpcResponse,
      `invalid response (${grpcStatusCode})`,
      'invalid response',
      `Received an unexpected reply from the server. ${pleaseUpdate}`,
    );
  }
}

export class InvalidChannelMessageError extends BackendClientDomainError {
  constructor() {
    super(
      BackendClientErrorCode.InvalidChannelMessage,
      'invalid channel message',
      'Invalid channel message',
      `The message received on the channel is invalid. ${pleaseUpdate}`,
    );
  }
}

export class RequiredFieldMissingError extends BackendClientDomainError {
  constructor() {
    super(BackendClientErrorCode.RequiredFieldMissing, 'required field missing');
  }
}
